import { render } from "./HomeHistoryRow.vue?vue&type=template&id=2ddd2c50&scoped=true"
import script from "./HomeHistoryRow.vue?vue&type=script&lang=js"
export * from "./HomeHistoryRow.vue?vue&type=script&lang=js"

import "./HomeHistoryRow.vue?vue&type=style&index=0&id=2ddd2c50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ddd2c50"

export default script